import { Button, Typography } from "@material-ui/core";
import React, { useMemo } from "react";
import { TextField, MenuItem, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
  },
  content: {
    flexGrow: 1,
  },
  textField: {
    width: "100%",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    textTransform: "none",
  },
  textFieldWrapper: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  textArea: {
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  charCounter: {
    alignSelf: "fex-end",
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
  },
}));

export default function RoleDetails({
  setShowComponent,
  setOpen,
  roleInfo,
  setRoleInfo,
  departmentAPI,
}) {
  const classes = useStyles();
  const [department, setDepartment] = React.useState(roleInfo.department);
  const [roleName, setRoleName] = React.useState(roleInfo.roleName);
  const [roleDescription, setRoleDescription] = React.useState(
    roleInfo.roleDescription
  );
  const [roleType, setRoleType] = React.useState(roleInfo.roleType);
  const [error, setError] = React.useState(null);

  const departmentOptions = useMemo(() => {
    if (
      localStorage?.roleName === "Admin" &&
       (localStorage?.departmentId === "null" ||
     Number(localStorage?.getItem("departmentId")) === 1 )
      ) {
      return (
        departmentAPI?.departmentDetailsList?.map((dept) => ({
          departmentID: dept.departmentID,
          departmentName: dept.departmentName,
        })) || []
      );
    } else {
      const localDepartmentId = Number(localStorage?.departmentId);
      return (
        departmentAPI?.departmentDetailsList
          ?.filter((dept) => dept.departmentID === localDepartmentId)
          .map((dept) => ({
            departmentID: dept.departmentID,
            departmentName: dept.departmentName,
          })) || []
      );
    }
  }, [departmentAPI]);

  const handleDepartmentChange = (e) => {
    const selectedDepartment = e.target.value;
    setDepartment(selectedDepartment);
  };

  const existingRoles = React.useMemo(() => {
    const departmentDetails = departmentAPI?.departmentDetailsList?.find(
      (dept) => dept.departmentName === department
    );

    if (departmentDetails) {
      return departmentDetails.rolesList
        .map((role) => role.role_name)
        .join(", ");
    }
    return "";
  }, [department, departmentAPI]);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleContinue = () => {
    setRoleInfo({
      department: department,
      roleName: roleName,
      roleDescription: roleDescription,
      roleType: "New",
    });
    setShowComponent("AccessPermission");
  };

  React.useEffect(() => {
    //Error handling
    if (!departmentAPI) {
      setError(true);
    } else {
      setError(null);
    }
  }, [departmentAPI]);

  if (error) {
    return (
      <Box
        style={{
          border: "2px solid rgb(255,0,0)",
          backgroundColor: "rgb(255,240,240)",
          Opacity: 1,
          textAlign: "center",
          padding: "0.8rem",
          fontSize: "0.875rem",
          marginBottom: "1.5em",
          marginTop: "1em",
        }}
      >
        {" "}
        <Typography variant="body2">
          Something went wrong. Please try again later.
        </Typography>
      </Box>
    );
  }
  if (!departmentAPI || !departmentAPI?.departmentDetailsList?.length) {
    return (
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50px",
          border: "2px solid #000",
          width: "100%",
          marginTop: "20px",
        }}
      >
        <Typography style={{ textAlign: "center" }}>
          No department records found.
        </Typography>
      </Box>
    );
  }

  return (
    <Box style={{ marginTop: "8px" }} className={classes.container}>
      <Box className={classes.content}>
        <Typography style={{ fontSize: "16px", fontWeight: 500 }} gutterBottom>
          Role Details
        </Typography>
        <Typography
          variant="body1"
          style={{ fontSize: "14px", fontWeight: 500 }}
        >
          Select Department
          <span style={{ color: "red" }}> *</span>
        </Typography>
        <TextField
          size="small"
          select
          value={department}
          onChange={handleDepartmentChange}
          variant="outlined"
          required
          className={classes.textField}
          SelectProps={{
            displayEmpty: true,
          }}
        >
          <MenuItem value="">Select department</MenuItem>
          {departmentOptions?.map((option) => (
            <MenuItem key={option.departmentID} value={option.departmentName}>
              {option.departmentName}
            </MenuItem>
          ))}

          {/* {departmentAPI?.departmentDetailsList?.map((option) => (
            <MenuItem key={option.departmentID} value={option.departmentName}>
              {option.departmentName}
            </MenuItem>
          ))} */}
        </TextField>
        <Typography
          variant="body1"
          style={{ marginTop: "8px", fontSize: "14px" }}
        >
          Existing Roles
        </Typography>
        <TextField
          disabled
          size="small"
          value={existingRoles}
          minRows={4}
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
          multiline
          className={classes.textField}
        />
        <Typography
          variant="body1"
          style={{ marginTop: "8px", fontWeight: 500, fontSize: "14px" }}
        >
          Role Name <span style={{ color: "red" }}>*</span>
        </Typography>
        <TextField
          size="small"
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
          onBlur={(e) => {
            const { value } = e.target;
            // Trim leading and trailing spaces for string values
            if (typeof value === "string" && value.trim() !== value) {
              setRoleName(value.trim());
            }
          }}
          variant="outlined"
          required
          className={classes.textField}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^a-zA-Z()/\\s ]/g, ""); // **Only allow letters and spaces**
          }}
        />
        <Typography
          variant="body1"
          style={{ marginTop: "8px", fontWeight: 500, fontSize: "14px" }}
        >
          Role Description <span style={{ color: "red" }}>*</span>
        </Typography>
        <Box className={classes.textFieldWrapper}>
          <TextField
            size="small"
            value={roleDescription}
            onChange={(e) => setRoleDescription(e.target.value)}
            onBlur={(e) => {
              const { value } = e.target;
              // Trim leading and trailing spaces for string values
              if (typeof value === "string" && value.trim() !== value) {
                setRoleDescription(value.trim());
              }
            }}
            variant="outlined"
            required
            multiline
            minRows={4}
            className={classes.textArea}
            inputProps={{ maxLength: 255 }}
          />
          <Typography className={classes.charCounter}>
            {roleDescription.length} / 255
          </Typography>
        </Box>

        {/* <Typography
          variant="body1"
          style={{ fontSize: "14px", fontWeight: 500, marginTop: "8px" }}
        >
          Role type
          <span style={{ color: "red" }}> *</span>
        </Typography> */}
        {/* <TextField
          size="small"
          select
          value={roleType}
          onChange={(e) => {
            setRoleType(e.target.value);
          }}
          variant="outlined"
          required
          className={classes.textField}
          SelectProps={{
            displayEmpty: true,
          }}
        > */}
        {/* <MenuItem value="Default">Default</MenuItem>
          <MenuItem value="New">New</MenuItem> */}
        {/* </TextField> */}
      </Box>

      <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          disableElevation
          onClick={handleCancel}
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          disabled={
            roleName === "" || roleDescription === "" || department === ""
          }
          style={{
            backgroundColor:
              roleName === "" || roleDescription === "" || department === ""
                ? "#cccccc"
                : "#286acf",
            color:
              roleName === "" || roleDescription === "" || department === ""
                ? "#777777"
                : "white",
            textTransform: "none",
          }}
          onClick={handleContinue}
          size="small"
        >
          Continue and add Permissions
        </Button>
      </Box>
    </Box>
  );
}
